<template>
    <div
        class="el-grid-card el-material-manager-grid el-grid-card--white"
        style="width: 100%"
    >
        <div class="el-grid-card__body">
            <el-row class="flex justify-between items-center filter-block">
                <div>
                    <div>
                        <el-date-picker
                            id="listDateTimeRange"
                            v-model="dateTimeRange"
                            @change="fetchByDateTimeRange"
                            format="yyyy-MM-dd HH:mm"
                            type="datetimerange"
                            range-separator="-"
                            :clearable="false"
                            :start-placeholder="$t('form.label.dateTimeFrom')"
                            :end-placeholder="$t('form.label.dateTimeUntil')"
                            :picker-options="pickerOptions"
                            class="el-date-picker-light"
                        >
                        </el-date-picker>
                        <v-btn-toggle
                            class="top-data-btn"
                            v-model="activeButton"
                        >
                            <v-btn
                                flat
                                color="dark"
                                @click="fetchByDateTimeRange(withinDay)"
                            >
                                {{ $t('button.text.today') }}
                            </v-btn>
                            <v-btn
                                flat
                                color="dark"
                                @click="fetchByDateTimeRange(withinFiveDays)"
                            >
                                {{ $t('button.text.days', { number: 5 }) }}
                            </v-btn>
                            <v-btn
                                flat
                                color="dark"
                                @click="fetchByDateTimeRange(withinSevenDays)"
                            >
                                {{ $t('button.text.days', { number: 7 }) }}
                            </v-btn>
                        </v-btn-toggle>
                    </div>
                </div>
                <v-flex xs12 sm6 md3>
                    <v-text-field
                        :label="$t('form.label.search')"
                        v-model="searchTerm"
                        append-icon="search"
                        class="el-light-search"
                    ></v-text-field>
                </v-flex>
                <v-flex
                    v-if="
                        selectedContainer &&
                        selectedContainer.ContainerType === 'CCC'
                    "
                    flex-row-reverse
                    xs12
                    sm6
                    md4
                >
                    <v-btn
                        round
                        color="primary"
                        @click.stop="openCreateBookingDialog()"
                        dark
                    >
                        {{ $t('button.text.createBooking') }}
                    </v-btn>
                </v-flex>
            </el-row>
            <el-row>
                <el-table
                    class="el-table__dark-expandable"
                    ref="materialsTable"
                    :data="searchResults"
                    row-key="WANotificationID"
                    v-loading="loading"
                    style="width: 100%"
                    border
                >
                    <el-table-column
                        min-width="60"
                        sortable
                        :label="$t('table.column.express')"
                        prop="IsExpress"
                    >
                        <template slot-scope="{ row }">
                            <ul class="express-icon-list" v-if="row.IsExpress">
                                <li class="express-icon"></li>
                            </ul>
                        </template>
                    </el-table-column>
                    <el-table-column
                        min-width="100"
                        sortable
                        :label="$t('table.column.status')"
                        prop="Status"
                    >
                        <template slot-scope="{ row }">
                            {{ getWAStatusDescription(row.Status) }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        min-width="100"
                        sortable
                        :label="$t('table.column.arrival')"
                        :sort-method="
                            (a, b) => sortByDate(a, b, 'actualArrivalDate')
                        "
                        prop="actualArrivalDate"
                    >
                    </el-table-column>
                    <el-table-column
                        min-width="115"
                        sortable
                        :label="$t('form.label.estimatedArrival')"
                        :sort-method="
                            (a, b) =>
                                sortByDate(a, b, 'actualEstimatedArrivalDate')
                        "
                        prop="actualEstimatedArrivalDate"
                    >
                    </el-table-column>
                    <el-table-column
                        min-width="100"
                        sortable
                        :label="$t('table.column.supplier')"
                        prop="SupplierName"
                    >
                    </el-table-column>
                    <el-table-column
                        min-width="100"
                        sortable
                        :label="$t('table.column.destination')"
                        prop="DestinationContainer"
                    >
                    </el-table-column>
                    <el-table-column
                        min-width="100"
                        sortable
                        :label="$t('table.column.unloadingArea')"
                        prop="UnloadingAreaName"
                    >
                    </el-table-column>
                    <el-table-column
                        min-width="100"
                        sortable
                        :label="$t('table.column.waitingArea')"
                        prop="WaitingAreaName"
                    >
                    </el-table-column>
                    <el-table-column width="110" :resizable="false">
                        <template slot-scope="{ row }">
                            <div
                                class="btn-action-wrapper"
                                v-if="
                                    getWAStatusDescription(row.Status) !==
                                    'EXPECTED'
                                "
                            >
                                <a
                                    href="#"
                                    class="btn-action"
                                    title="Confirm"
                                    v-if="row.Status !== 1"
                                    @click.prevent="
                                        changeStatus(1, row.WANotificationID)
                                    "
                                >
                                    <v-btn
                                        color="primary"
                                        style="margin-bottom: 2px"
                                        small
                                        >{{ $t('button.text.confirm2') }}</v-btn
                                    >
                                </a>
                                <a
                                    href="#"
                                    class="btn-action"
                                    v-if="row.Status !== 2"
                                    @click.prevent="
                                        changeStatus(2, row.WANotificationID)
                                    "
                                    title="Deny"
                                    style="margin-top: 2px"
                                >
                                    <v-btn
                                        color="error"
                                        style="margin-bottom: 2px"
                                        small
                                        >{{ $t('button.text.deny') }}</v-btn
                                    >
                                </a>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :label="$t('table.column.operations')"
                        width="150"
                        :resizable="false"
                    >
                        <template slot-scope="{ row }">
                            <div
                                class="btn-action-wrapper"
                                style="margin-top: 3px"
                            >
                                <a
                                    href="#"
                                    class="btn-action action-btn"
                                    title="Show Timeline"
                                    @click.stop="
                                        openTimeline(
                                            row.WANotificationID,
                                            'WA_NOTIFICATION',
                                            row.ReferenceCode
                                        )
                                    "
                                >
                                    <v-btn flat icon color="primary darken-3">
                                        <v-icon>info</v-icon>
                                    </v-btn>
                                </a>
                                <a
                                    href="#"
                                    class="btn-action"
                                    title="Open Chat"
                                    style="width: 30px"
                                    @click.prevent="openChat(row)"
                                >
                                    <v-badge color="red" style="width: 30px">
                                        <template
                                            v-slot:badge
                                            v-if="
                                                row.UnReadCount &&
                                                row.UnReadCount > 0
                                            "
                                        >
                                            <span>{{ row.UnReadCount }}</span>
                                        </template>
                                        <v-btn flat icon color="info darken-3">
                                            <v-icon>message</v-icon>
                                        </v-btn>
                                    </v-badge>
                                </a>
                                <a
                                    href="#"
                                    class="btn-action action-btn"
                                    title="Edit"
                                    @click.prevent="edit(row)"
                                >
                                    <v-btn flat icon color="cyan darken-3">
                                        <v-icon>mode_edit</v-icon>
                                    </v-btn>
                                </a>
                                <a
                                    href="#"
                                    class="btn-action action-btn"
                                    title="Delete"
                                    @click.prevent="remove(row)"
                                >
                                    <v-btn flat icon color="red darken-3">
                                        <v-icon>delete</v-icon>
                                    </v-btn>
                                </a>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    layout="total, sizes, prev, pager, next"
                    :page-count="totalPages"
                    :total="totalCount"
                    :current-page="currentPage"
                    :page-sizes="[10, 20, 30, 40, 50, 100, 500]"
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
                    style="margin-top: 10px"
                >
                </el-pagination>
            </el-row>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import { DateTime } from 'luxon'
import moment from 'moment'
import { mapGetters } from 'vuex'
import InteractWithSort from '../../mixins/interact-with-sort'
import InteractWithDates from '../../mixins/interact-with-dates'
import WANotificationsMixin from '../../mixins/waiting-area-notifications-mixin'
import UserGroupsMixin from '../../mixins/user-groups-mixin'
import ChatMixin from '../../mixins/chat-mixin'

export default {
    name: 'waiting-area-list',

    data() {
        return {
            loading: false,
            activeButton: 0,
            dateTimeRange: [],
            data: [],
            container: '',
            hasDescription: false,
            searchTerm: '',
            searchResults: [],
            showCreateBookingBtn: true,
            notificationType: 'DEFAULT',
            totalPages: 1,
            currentPage: 1,
            totalCount: 0,
            pageSize: 10,
        }
    },

    mixins: [
        InteractWithDates,
        InteractWithSort,
        WANotificationsMixin,
        UserGroupsMixin,
        ChatMixin,
    ],

    created() {
        this.fetch(
            1,
            this.selectedContainer,
            this.dateTimeRange,
            true,
            this.selectedContainer.ContainerType
        )

        Events.$on('date-range-changed', () => {
            this.fetch(1, null, this.dateTimeRange)
        })

        Events.$on('wa-notifications-refresh', () => {
            this.fetch(1, null, this.dateTimeRange)
        })
    },

    beforeDestroy() {
        Events.$off('date-range-changed')
        Events.$off('wa-notifications-refresh')
    },

    watch: {
        selectedContainer: function (container) {
            this.fetch(1, container, this.dateTimeRange)
        },

        searchTerm: _.debounce(async function () {
            if (this.searchTerm !== '') {
                this.searchResults = await this.$search(
                    this.searchTerm,
                    this.notifications,
                    this.searchOptions
                )
            } else {
                this.searchResults = this.notifications
            }
        }, 500),
    },
    computed: {
        ...mapGetters(['isBlc', 'selectedContainer']),

        pickerOptions() {
            return {
                firstDayOfWeek: 1,
            }
        },

        notifications() {
            this.hasDescription = false

            let data = this.data

            return data.map((item) => {
                let actualArrivalDate = ''
                if (item.ActualArrival) {
                    // const date = DateTime.fromISO(item.ActualArrival, {
                    //     zone: 'utc',
                    // }).toJSDate()
                    actualArrivalDate = moment(item.ActualArrival).format(
                        'YYYY-MM-DD HH:mm'
                    )
                }

                let actualEstimatedArrivalDate = ''
                if (item.EstimatedArrival) {
                    const date = DateTime.fromISO(item.EstimatedArrival, {
                        zone: 'utc',
                    }).toJSDate()
                    actualEstimatedArrivalDate =
                        moment(date).format('YYYY-MM-DD HH:mm')
                }

                return {
                    actualArrivalDate,
                    actualEstimatedArrivalDate,
                    ...item,
                }
            })
        },

        searchOptions() {
            return {
                keys: [
                    'DestinationContainer',
                    'SupplierName',
                    'WaitingAreaName',
                    'ActualArrival',
                    'UnloadingAreaName',
                    'Status',
                    'LastMessage',
                ],
            }
        },
    },

    methods: {
        fetchByDateTimeRange(range) {
            this.activeButton = ''
            this.fetch(1, this.selectedContainer, range)
        },

        async fetch(
            currentPage,
            container = null,
            range = [],
            loading = true,
            type = 'CCC'
        ) {
            if (!currentPage) {
                currentPage = 1
            }

            this.loading = loading
            this.currentPage = currentPage

            container = container ? container : this.selectedContainer

            range = range.length ? range : this.withinDay

            let dateTimeFormat = process.env.VUE_APP_DATETIME_FORMAT

            let dateTimeFrom = DateTime.fromISO(range[0].toISOString())
            let dateTimeTo = DateTime.fromISO(range[1].toISOString())

            // set end and start time to day start and day end if it doesn't contains time
            if (
                dateTimeFrom.startOf('day').valueOf() ===
                    dateTimeFrom.valueOf() &&
                dateTimeTo.startOf('day').valueOf() === dateTimeTo.valueOf()
            ) {
                let start = dateTimeFrom.startOf('day')
                let end = dateTimeTo.endOf('day')

                dateTimeFrom = start.toFormat(dateTimeFormat)
                dateTimeTo = end.toFormat(dateTimeFormat)

                range = [start.toJSDate(), end.toJSDate()]
            } else {
                dateTimeFrom = dateTimeFrom.toFormat(dateTimeFormat)
                dateTimeTo = dateTimeTo.toFormat(dateTimeFormat)
            }
            const req = {
                ContainerID: container.ContainerID,
                CurrentPage: this.currentPage,
                PageSize: this.pageSize,
            }
            try {
                let { data } = await this.$http.post(
                    `/BLC/${container.ContainerID}/WANotification/From/${dateTimeFrom}/To/${dateTimeTo}`,
                    req
                )
                this.totalPages = data.TotalPages
                this.currentPage = data.CurrentPage
                this.totalCount = data.TotalCount
                this.data = data.result
                this.searchResults = this.notifications
                this.dateTimeRange = range
            } catch (error) {
                this.$message({
                    type: 'error',
                    showClose: true,
                    message: this.$i18n.i18next.t('message.error.general'),
                })
            }
            this.loading = false
        },

        openCreateBookingDialog(data) {
            Events.$emit('toggle-wanotification-create-view', true, data)
        },

        edit(waNotification) {
            this.openCreateBookingDialog(waNotification)
        },

        async remove(waNotification) {
            try {
                await this.$confirm(
                    this.$i18n.i18next.t('message.warning.delete', {
                        section: this.$i18n.i18next.t('form.title.waitingArea'),
                    }),
                    'Warning',
                    {
                        confirmButtonText: this.$i18n.i18next.t(
                            'button.text.confirm'
                        ),
                        cancelButtonText:
                            this.$i18n.i18next.t('button.text.cancel'),
                        type: 'warning',
                    }
                )

                await this.$http.delete(
                    `/BLC/${this.selectedContainer.ContainerID}/WANotification/${waNotification.WANotificationID}`
                )
                this.fetch(1, this.selectedContainer, this.dateTimeRange, false)

                this.$message({
                    type: 'success',
                    showClose: true,
                    message: this.$i18n.i18next.t('message.success.deleted', {
                        section: this.$i18n.i18next.t('form.title.waitingArea'),
                    }),
                })
            } catch (e) {
                console.error(e)
                if (e !== 'cancel') {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: this.$i18n.i18next.t('message.error.general'),
                    })
                }
            }
        },

        handleCurrentChange(val) {
            this.currentPage = val
            this.fetch(val, null, this.dateTimeRange)
        },

        handleSizeChange(val) {
            this.pageSize = val
            this.fetch(this.currentPage, null, this.dateTimeRange)
        },

        async changeStatus(status, wANotificationID) {
            const message =
                status === 2
                    ? 'message.warning.deny'
                    : 'message.warning.confirm'
            try {
                await this.$confirm(this.$i18n.i18next.t(message), 'Warning', {
                    confirmButtonText: this.$i18n.i18next.t(
                        'button.text.confirm'
                    ),
                    cancelButtonText:
                        this.$i18n.i18next.t('button.text.cancel'),
                    type: 'warning',
                })
                this.updateStatus(status, wANotificationID)
                return true
            } catch (e) {
                console.error(e)
                return false
            }
        },

        async updateStatus(status, wANotificationID) {
            try {
                await this.$http.post(
                    `/WANotification/${wANotificationID}/Status`,
                    {
                        Status: status,
                    }
                )

                this.$message({
                    type: 'success',
                    showClose: true,
                    message: this.$i18n.i18next.t('message.success.updated', {
                        section: this.$i18n.i18next.t('text.booking'),
                    }),
                })

                this.fetch(this.currentPage, null, this.dateTimeRange)
            } catch (error) {
                console.error(error)
                this.$message({
                    type: 'error',
                    showClose: true,
                    message: this.$i18n.i18next.t('message.error.general'),
                })
            }
        },

        async openChat(data) {
            if (!data.ChannelId) {
                data.ChannelId = await this.createChannel(data)
            }
            if (data.ChannelId) {
                Events.$emit('show-chat', true)
                this.$nextTick(() => {
                    Events.$emit('open-chat', true, data.ChannelId)
                })
                data.UnReadCount = 0
            }
        },

        openTimeline(id, type, code) {
            Events.$emit('show-timeline', id, type, code)
        },
    },
}
</script>
<style scoped>
.el-table tbody tr.el-table__row td .btn-action .btn {
    margin: 0;
}
.action-btn {
    width: 30px !important;
}
</style>
<style>
.badge__badge,
.badge__badge .icon {
    top: -2px !important;
    right: -5px !important;
    height: 15px !important;
    width: 15px !important;
    font-size: 8px !important;
    line-height: 1px !important;
    font-weight: bold !important;
}
</style>